/**
 * User Display Utilities
 *
 * Helper functions for resolving display names and avatar URLs
 * with appropriate fallbacks.
 *
 * The single source of truth for user identity (user_id, username, avatar_url)
 * is the User Profiles DynamoDB table. The backend enriches all forum threads
 * and replies with username/avatar at read time, so the frontend simply
 * picks the best available field.
 *
 * Requirements: 17.7, 17.8, 17.9, 17.10
 */

/**
 * Resolve the display name for a user.
 * Priority: username → display_name → fallback.
 */
export function resolveDisplayName(opts: {
    username?: string | null;
    display_name?: string | null;
    email?: string | null;
}): string {
    if (opts.username) return opts.username;
    if (opts.display_name) return opts.display_name;
    return 'User';
}

/**
 * Resolve the display name for a forum author (thread or reply).
 * Priority: username → display_name → 'User'.
 *
 * The backend enriches threads/replies with the username from the
 * User Profiles table, so username should always be present for
 * users who have set one.
 */
export function resolveAuthorDisplayName(opts: {
    username?: string | null;
    display_name?: string | null;
}): string {
    if (opts.username) return opts.username;
    if (opts.display_name) return opts.display_name;
    return 'User';
}
